import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
// COMPONENTS
import Header from './components/Layout/Header';
// PAGES
// import handleErrorComponent from "./utils/errors/handleErrorComponent";
import LoadingIndicator from "canvas-core-react/lib/LoadingIndicator";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";

const AppContext = createContext(null);

const contextDefaultValue = {
	rut: '',
	error_rut: null,
	numSerie: '',
	error_numSerie: null,
	autorizacion_dataEntry: false,
	error_input_salary: null,
	error: false,
	ErrorComponent: null,
	loading: false,
	depositType: null,
	currency: 'Pesos',
	plazo: '',
	amount: '',
	error_input_amount: false,
	error_input_plazo: false
}

const AppProvider = ({ children, initValue = contextDefaultValue }) => {
	const [state, setState] = useState(initValue);


	const changeItem = useCallback((item) => setState((prevState) => ({ ...prevState, ...item })), []);
	const changeItem_ = useCallback((item) => setState((prevState) => ({ ...prevState, ...item })), []);

	const displayError = useCallback((error, callBackFn, component) => {
		const Comp = component;
		// const Comp = component || handleErrorComponent(error, callBackFn);
		changeItem({ error: true, ErrorComponent: Comp });
	}, [changeItem]);

	useEffect(() => {
		window.scrollTo(0, 0);
		changeItem({
			error: false,
			ErrorComponent: null,
			loading: false,
		});
	}, [changeItem]);

	const { loading, error, ErrorComponent } = state;

	const iconText = {
		body: "Cargando...",
	};

	return (
		<AppContext.Provider value={{ state, changeItem, displayError, changeItem_ }}>
			<div id="LayoutMain_container">
				<Header />
				{children}
				{error && ErrorComponent}
				{loading && (
					<div className="loading__container">
						<LoadingIndicator size="large" />
						<section>
							<TextSubtitle type="1" component="h2">
								{iconText.body}
							</TextSubtitle>
						</section>
					</div>
				)}
			</div>
		</AppContext.Provider>
	)
}
export default AppProvider;
export const useAppContext = () => useContext(AppContext);
export { AppContext };
